import { useQuery } from '@tanstack/react-query';
import { getOAuthConsentKey } from './oauth.keys';
import { getOAuthConsent } from './oauth.repository';

interface UseOAuthConsentQueryParams {
  oauthRequestId: string;
  enabled: boolean;
}

export const useOAuthConsentQuery = ({ oauthRequestId, enabled }: UseOAuthConsentQueryParams) =>
  useQuery({
    queryKey: getOAuthConsentKey(oauthRequestId),
    queryFn: async () => {
      const response = await getOAuthConsent(oauthRequestId);

      if (!response.ok || !response.data) {
        throw response.originalError;
      }

      return response.data;
    },
    enabled,
    retry: false,
  });
